module.exports = __webpack_public_path__ + "static/media/8a.4ac5bf58.ogg";